import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { addFeedback } from '../../../../firebase/services';
import './settings.css'; // Reusing the settings CSS for consistency

const FeedbackScreen = () => {
  const navigate = useNavigate();
  const [category, setCategory] = useState('General Feedback');
  const [feedbackText, setFeedbackText] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(''); // Clear previous messages

    if (!feedbackText.trim()) {
      setMessage('Feedback cannot be empty.');
      return;
    }

    try {
      // Assuming addFeedback takes category and feedbackText
      await addFeedback({ category, feedbackText });
      setMessage('Thank you! Your feedback has been submitted successfully.');
      setFeedbackText(''); // Clear the form
      setCategory('General Feedback');
    } catch (error) {
      console.error('Error submitting feedback:', error);
      setMessage('Failed to submit feedback. Please try again.');
    }
  };

  return (
    <div className="settings-screen">
      <header className="settings-header">
        <button onClick={() => navigate(-1)} className="back-button">
          &larr;
        </button>
        <h1>Provide Feedback</h1>
      </header>
      <main className="settings-content">
        <p className="feedback-instruction">
          We value your input! Please share any feedback, suggestions, or issues you've encountered. Your insights help us make the Lightway App better for everyone.
        </p>
        <form onSubmit={handleSubmit} className="feedback-form">
          <div className="form-group">
            <label htmlFor="category">Category:</label>
            <select
              id="category"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              className="feedback-select"
            >
              <option value="General Feedback">General Feedback</option>
              <option value="Bug Report">Bug Report</option>
              <option value="Suggestion">Suggestion</option>
              <option value="Praise">Praise</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="feedbackText">Your Feedback:</label>
            <textarea
              id="feedbackText"
              value={feedbackText}
              onChange={(e) => setFeedbackText(e.target.value)}
              placeholder="Tell us what's on your mind..."
              rows="6"
              className="feedback-textarea"
            ></textarea>
          </div>
          <button type="submit" className="button">
            Submit Feedback
          </button>
        </form>
        {message && <p className="feedback-message">{message}</p>}
      </main>
    </div>
  );
};

export default FeedbackScreen;
